import { render, staticRenderFns } from "./SentEnvelopesCardTable.vue?vue&type=template&id=2f534a32&lang=pug"
import script from "./SentEnvelopesCardTable.vue?vue&type=script&lang=js"
export * from "./SentEnvelopesCardTable.vue?vue&type=script&lang=js"
import style0 from "./SentEnvelopesCardTable.vue?vue&type=style&index=0&id=2f534a32&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports